module.exports = __webpack_public_path__ + "1792395595471/images/brandbook-half-o-side.46617fe.svg";